import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

interface Pairing {
  messages;
  topic: string;
}

export const updateSeenMessage = (userId) => {
  return Http.request<Pairing>({
    method: 'GET',
    url: `${API_CHAT_URL}/message/${userId}`,
  });
};
